<template>
  <div
    style="width: 112px; height: 112px;"
    class="rounded-lg  d-flex flex-column justify-center ma-0 pa-0 imageEmptyStateStyle blue-grey lighten-3"
  >
    <v-icon size="40" color="blue-grey">{{ icon }}</v-icon>
  </div>
</template>

<script>
export default {
  name: 'ImageEmptyState',
  props: {
    icon: String,
  },
}
</script>
